import { ADMIN_GROUP_LIST } from './index';
import { Action } from '../action';
import { AccessCodeGroupInfo } from '@shared/core';

export class AdminGroupListInitAction implements Action {
	readonly type = ADMIN_GROUP_LIST.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupListDestroyAction implements Action {
	readonly type = ADMIN_GROUP_LIST.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupListHydrateAction implements Action {
	readonly type = ADMIN_GROUP_LIST.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupListHydrateSuccessAction implements Action {
	readonly type = ADMIN_GROUP_LIST.HYDRATE_SUCCESS;
	constructor(
		public payload: AccessCodeGroupInfo[],
		public correlationId?: number
	) {}
}

export class AdminGroupListHydrateFailureAction implements Action {
	readonly type = ADMIN_GROUP_LIST.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminGroupListDeleteAction implements Action {
	readonly type = ADMIN_GROUP_LIST.DELETE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupListDeleteSuccessAction implements Action {
	readonly type = ADMIN_GROUP_LIST.DELETE_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupListDeleteFailureAction implements Action {
	readonly type = ADMIN_GROUP_LIST.DELETE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminGroupListClickAddAction implements Action {
	readonly type = ADMIN_GROUP_LIST.CLICK_ADD;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupListClickEditAction implements Action {
	readonly type = ADMIN_GROUP_LIST.CLICK_EDIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupListClickConfigurationAction implements Action {
	readonly type = ADMIN_GROUP_LIST.CLICK_CONFIGURATION;
	constructor(
		public payload: AccessCodeGroupInfo,
		public correlationId?: number
	) {}
}

export class AdminGroupListClickDeleteAction implements Action {
	readonly type = ADMIN_GROUP_LIST.CLICK_DELETE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupListSelectAction implements Action {
	readonly type = ADMIN_GROUP_LIST.SELECT;
	constructor(
		public payload: AccessCodeGroupInfo,
		public correlationId?: number
	) {}
}

export class AdminGroupListSelectOrganizationGroupAction implements Action {
	readonly type = ADMIN_GROUP_LIST.SELECT_ORGANIZATION_GROUP;
	constructor(
		public payload: string,
		public correlationId?: number
	) {}
}

export class AdminGroupListClickShowServicesAction implements Action {
	readonly type = ADMIN_GROUP_LIST.CLICK_SHOW_SERVICES;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupListClickShowCodesAction implements Action {
	readonly type = ADMIN_GROUP_LIST.CLICK_SHOW_CODES;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupListClickShowMetasAction implements Action {
	readonly type = ADMIN_GROUP_LIST.CLICK_SHOW_METAS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminGroupListClickOrganizationBacklinkAction implements Action {
	readonly type = ADMIN_GROUP_LIST.CLICK_ORGANIZATION_BACKLINK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
